// export const url = "http://localhost:9000/todos";
export const url = "https://redux-todo-sr.herokuapp.com/todos";